import { paymentProvider } from "@@/shared/payments/payment-providers";
import { z } from "zod";

const payRequestPaymentStripeDataZodObject = z.object({
    paymentProvider: z.literal(paymentProvider.STRIPE),
    stripeCheckoutSessionId: z.string(),
    paymentIntentId: z.string(),
});

export { payRequestPaymentStripeDataZodObject };
